module.exports = __webpack_public_path__ + "img/code-reviewer.e096447a.webp";